// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"1a389e25","453":"6d84b53b","626":"fb89fe9d"}[chunkId] + ".chunk.js";
};